import { renderInvalidatedColors } from './chart-util';

/**
 * Adds options for LINE charts.
 */
export function preRender(data, options) {
  data.plotOptions.line = {
    lineWidth: 3,
    linecap: 'square',
    enableMouseTracking: options.interactive,
    states: {
      hover: {
        halo: {
          opacity: 1,
          size: 4
        },
        lineWidthPlus: 0
      }
    },
  };
  data.plotOptions.series = {
    marker: {
      symbol: 'circle',
      radius: 0,
      lineWidth: 0,
      lineColor: null
    }
  };
  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      data.plotOptions.line.lineWidth = 1.5;
      data.plotOptions.line.linecap = 'round';
    }
  }
  return data;
}


export function postRender(highchart, options) {
  roundLineJoins(highchart);
}


function roundLineJoins(highchart) {
  const selector = 'g.highcharts-series-group g.highcharts-series path';
  const paths = highchart.container.querySelectorAll(selector);
  for (let i = 0; i < paths.length; i++) {
    paths[i].setAttribute('stroke-linejoin', 'bevel');
  }
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    renderInvalidatedColors(rendered, invalidated);
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/chart-line.js